import { Component, OnInit, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { DatePipe } from '@angular/common';
import { Helper } from '../../../helpers/helper';
import { ClientesService } from '../../../services/Clientes.service';

@Component({
  selector: 'app-detalle-solicitud',
  templateUrl: './detalle-solicitud.component.html',
  styleUrls: ['./detalle-solicitud.component.css']
})
export class DetalleSolicitudComponent implements OnInit {
  @Input() ID_SOLICITUD: number;
  solicitud: any;
  actividades = [];
  fotoCedula = 'assets/img/cedula.png';

  constructor(
    public activeModal: NgbActiveModal,
    public helper: Helper,
    private clienteService: ClientesService
  ) {
  }

  ngOnInit() {
    const subscription = this.clienteService.detalleSolicitud(this.ID_SOLICITUD)
    .subscribe((res: any) => {
      this.solicitud = res.solicitud;
      this.actividades = res.actividades;

      if (res.solicitud.foto) {
        this.fotoCedula = `${this.helper.baseUrl}/uploads/clientes/${this.helper.compania}/${res.identificacion}/cedulas/${res.foto}`;
      }

      if (subscription) {
        subscription.unsubscribe();
      }
    });
  }

  datePipe(fecha: string) {
    if (fecha === '0000-00-00 00:00:00') {
      return ''
    } else {
      return new DatePipe('en-US').transform(fecha, 'dd-MM-yyyy');
    }
  }
}



// WEBPACK FOOTER //
// C:/Users/AINSA WEB/Documents/proyects/ROUTEMEE/routemee-web-application/src/app/components/modals/detalle-solicitud/detalle-solicitud.component.ts